angular.module("admin.services").factory("CnpjUtils", function () {
  function clean(value) {
    if (!value) return "";
    return String(value)
      .replace(/[.\/-]/g, "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 14);
  }

  function isAlphanumeric(value) {
    return /[A-Z]/i.test(String(value || ""));
  }

  function format(value) {
    if (value === null || value === undefined || value === "") {
      return value;
    }

    const raw = clean(value);
    if (!raw) return value;

    if (raw.length <= 2) return raw;
    if (raw.length <= 5) return `${raw.slice(0, 2)}.${raw.slice(2)}`;
    if (raw.length <= 8) {
      return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5)}`;
    }
    if (raw.length <= 12) {
      return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8)}`;
    }
    return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12, 14)}`;
  }

  function normalize(value) {
    if (!value) return value;

    const raw = clean(value);
    if (!raw) return value;

    if (isAlphanumeric(raw)) return raw;

    if (raw.length === 13) return "0" + raw;
    return raw.padStart(14, "0");
  }

  function charValue(char) {
    return char.charCodeAt(0) - 48;
  }

  function calcCheckDigit(base) {
    var weights = [2, 3, 4, 5, 6, 7, 8, 9];
    var sum = 0;

    for (var i = base.length - 1; i >= 0; i--) {
      sum += charValue(base[i]) * weights[(base.length - 1 - i) % 8];
    }

    var remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  }

  function hasValidCheckDigits(value) {
    var raw = clean(value);
    if (raw.length !== 14) return false;
    if (/^(.)\1+$/.test(raw)) return false;

    var dv1 = calcCheckDigit(raw.slice(0, 12));
    if (String(dv1) !== raw.charAt(12)) return false;

    var dv2 = calcCheckDigit(raw.slice(0, 12) + dv1);
    return String(dv2) === raw.charAt(13);
  }

  function hasValidFormat(value) {
    if (value === null || value === undefined || value === "") return true;

    const raw = clean(value);
    if (!raw) return true;

    return /^[A-Z0-9]{1,14}$/.test(raw);
  }

  function isComplete(value) {
    if (value === null || value === undefined || value === "") return true;

    const raw = clean(value);
    if (!raw) return true;

    return raw.length === 14;
  }

  function isValid(value) {
    if (!hasValidFormat(value) || !isComplete(value)) return false;

    var raw = clean(value);
    if (!raw) return true;

    return hasValidCheckDigits(raw);
  }

  return {
    clean: clean,
    format: format,
    normalize: normalize,
    isAlphanumeric: isAlphanumeric,
    hasValidFormat: hasValidFormat,
    isComplete: isComplete,
    hasValidCheckDigits: hasValidCheckDigits,
    isValid: isValid,
  };
});
